import { Expose } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

export class RepaymentObligation extends BaseModel {
    @Expose()
    amount = 0.0;
    @Expose()
    currency = "S/";
}
